import {Injectable} from '@angular/core';
import {FormGroup, AbstractControl} from '@angular/forms';
import {TooltipDirective} from 'ngx-bootstrap/tooltip';

@Injectable()
export class FormHelperService {
    hasError(form: FormGroup, ...prop: string[]) {
        const control = this.getControl(form, ...prop);
        return !control.valid && control.touched;
    }
    hasErrorTooltip(form: FormGroup, tooltip: TooltipDirective, ...prop: string[]) {
        const control = this.getControl(form, ...prop);
        if(!control.valid && control.touched){
            tooltip.show();
        } else {
            tooltip.hide();
        }
        return !control.valid && control.touched;
    }
    getControl(form: FormGroup, ...prop: string[]): AbstractControl {
        if (prop.length === 1) {
            return form.controls[prop[0]];
        }
        return this.getControl(<any>form.controls[prop[0]], ...prop.slice(1));
    }
}